import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-like',
  templateUrl: './like.component.html',
  styleUrls: ['./like.component.scss'],
})
export class LikeComponent {
  @Input('likes') likes: string = '';
  @Input('isLiked') isLiked: boolean | number = false;
}
